import { HttpClientConfig } from '../../../useHttpClientConfig'
import { apiVersion, service } from '../service'
import { GetCalendarIntegrationAppointmentTypeMappingsResponse } from '../../../../types/calendarIntegrationAppointmentTypeMapping'
import { applySearchParams, urlToPathnameAndSearch } from '../utils'

type CalendarIntegrationAppointmentTypeMappingsFilters = {
  shop_id?: string
  delivery_model?: string
  page_size?: number
}

const pathname = `/api/${apiVersion}/calendar-integration-appointment-type-mappings`

const makeGetCalendarIntegrationAppointmentTypeMappings =
  (baseUrl: string, config: HttpClientConfig) =>
  async (filters: CalendarIntegrationAppointmentTypeMappingsFilters): Promise<GetCalendarIntegrationAppointmentTypeMappingsResponse> => {
    const url = new URL(pathname, baseUrl)

    applySearchParams(url, { page_size: 10, ...filters })

    const pathnameAndSearch = urlToPathnameAndSearch(url)
    const response = await service(baseUrl).get<GetCalendarIntegrationAppointmentTypeMappingsResponse>(pathnameAndSearch, config)

    return response.data
  }

export { makeGetCalendarIntegrationAppointmentTypeMappings }
export type { CalendarIntegrationAppointmentTypeMappingsFilters }
